import { useEffect, useState } from "react";
import { sizeKbFromHeaders } from "@greg-chick/shared";

/**
 * 파일 무게(KB) — 받기 시작하자마자 헤더만 읽고 끊는다. 못 재면 null.
 * 층 그림(마법 꾸미기)·3D 파일(층 3D · AR 보기 ④)이 같이 쓴다.
 *
 * 🔴 전에는 `Range` 헤더를 붙였다. 관리자와 그림은 **출처가 달라** 그 헤더가 사전 확인(OPTIONS)을 부르는데
 *    운영은 405(웹 /art)·404(엣지 /assets)를 준다 — 요청이 통째로 막혀 **무게가 운영에서 늘 안 보였다**
 *    (🪄 마법 점검이 2026-09-13 에 같은 함정을 밟았다). 헤더 없는 GET 은 사전 확인이 없다. 읽는 법은 shared 한 곳.
 */
export function useKb(url: string | undefined): number | null {
  const [kb, setKb] = useState<number | null>(null);
  useEffect(() => {
    setKb(null);
    if (!url) return;
    let alive = true;
    const ac = new AbortController();
    void fetch(url, { signal: ac.signal })
      .then((r) => {
        const got = sizeKbFromHeaders(r.headers.get("content-range"), r.headers.get("content-length"));
        if (alive && got !== null) setKb(got);
        ac.abort(); // 몸통은 필요 없다 — 3D 파일은 수 MB 다
      })
      .catch(() => undefined); // 무게는 곁들이는 정보다 — 못 재면(끊은 것 포함) 아무 말도 안 한다(편집은 막지 않는다)
    return () => {
      alive = false;
      ac.abort();
    };
  }, [url]);
  return kb;
}
